import {getLoggedIn} from "@awe-web/shared/lib";
import {B2B_Dashboard} from "../../../routing/routes.js";

export const initialize = () => async (dispatch, getState) => {
  if (getLoggedIn(getState())) {
    return B2B_Dashboard.path();
  }
};
